import React, {useMemo, useState} from 'react';
import {Drawer, Menu} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Footer from "../../home/Footer";
import {Colors} from '@arboxappv4/shared/src/styles/Colors'
import {
    Btn,
    ClickableDiv,
    FlexColumnSection,
    FlexRowSection,
    SeparatorVerticalDiv,
} from "../../../styles/globalStyles";
import {
    closeModal,
    LOGIN_MODAL, MOBILE_MENU_DRAWER,
    openModal
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {changeLangByCode, isRTL} from "../../../helpers/i18n";
import {
    getHourIcon,
    getLocationsForPurchase,
    getOptionalRoutesArray, isLocationIL, onLinkClicked
} from "../../../helpers/functions";
import iconGenerator from "../../../helpers/IconGenerator";
import {t} from "i18next";
import {logout} from "@arboxappv4/shared/src/redux/authSlice";
import Logo from "../../../components/Logo";
import {HEADER_SIGN_IN_CALLER} from "@arboxappv4/shared/src/helpers/constants";
import {flowOptions} from "../../../flowManager/FlowOptions";
import {PLUGIN_REFERER} from "../../../../../src/constants";
import {invoiceProviders} from "@arboxappv4/shared/src/constants/constants";

const MobileMenu = (props) => {
    const { isOpen, onClose } = props;
    const box = useSelector(state => state.site.box)
    const language = useSelector(state => state.site.language)
    const loggedIn = useSelector(state => state.auth.loggedIn)
    const userBox = useSelector(state => state.user.activeUsersBoxes)
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const flowName = useSelector(state => state.stepper.flowName)
    const referrer = useSelector(state => state.site.referrer)

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const pageInfo = useMemo(() => box ? getOptionalRoutesArray() : null, [box]);
    const locations = useMemo(() => getLocationsForPurchase(),[box])
    const hideLogin = useMemo(() => referrer === PLUGIN_REFERER && ![flowOptions.REGISTER, flowOptions.MEMBERSHIP_PURCHASE, flowOptions.DIRECT_MEMBERSHIP_PURCHASE].includes(flowName),[referrer, flowName])
    const hasInvoicesPage = useMemo(() => box && isLocationIL() && box.invoice_provider === invoiceProviders.RIVHIT ,[box])

    const goToLink = (to) => {
        onLinkClicked(to, navigate)
        onClose()
    }

    const openLogin = () => {
        dispatch(closeModal({modalName: MOBILE_MENU_DRAWER}))
        dispatch(openModal({modalName: LOGIN_MODAL, props: {caller: HEADER_SIGN_IN_CALLER}}))
    }

    const onChangeLang = (code) => {
        changeLangByCode(code, dispatch, navigate)
        dispatch(closeModal({modalName: MOBILE_MENU_DRAWER}))
    }

    const logoutUser = () => {
        dispatch(logout())
        setTimeout(() => window.location.reload(), 10)
    }

    return (
        <Drawer
            title={<Logo/>}
            headerStyle={{alignItems: 'flex-start', padding: '16px', borderBottom: 0}}
            placement={'right'}
            width={'100%'}
            open={isOpen}
            closable={false}
            style={{direction: isRTL() ? 'rtl' : 'ltr'}}
            extra={<div onClick={onClose}><FontAwesomeIcon icon={light('xmark')}/></div>}
            footer={<Footer hidePoweredByMobile={true}/>}
            footerStyle={{padding: '24px 16px', borderTop: `1px solid ${Colors.siteScheduleBorder}`, display:'flex', alignItems: 'flex-end'}}
            bodyStyle={{padding: '16px', display: 'flex'}}
        >
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
                    { pageInfo.map(link => (
                        <div onClick={() => link.to ? goToLink(link.to) : setOpenSubMenu(prev => prev === link.name ? null : link.name)} key={`mobile-menu-item-${link.to}`} style={{display: 'flex', flexDirection: 'column', flex: 1, borderBottom: `1px solid ${Colors.siteScheduleBorder}`, paddingBottom: 10, gap: '15px'}}>
                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold'}}>
                                {t(link.name)}
                                <FontAwesomeIcon icon={light('chevron-right')} rotation={openSubMenu === link.name ? 270 : isRTL() ? 180 : 0} color={Colors.greyText}/>
                            </div>
                            {openSubMenu === link.name && link.children.map(subItem => <div onClick={() => goToLink(subItem.key)}>{subItem.label}</div>)}
                        </div>)
                    )}
                    { loggedIn && userBox &&
                        <FlexColumnSection gap={'16px'} flex={'unset'}>
                            <LoggedInUser gap={'10px'}>
                                <FontAwesomeIcon icon={iconGenerator({name: getHourIcon()})}/>
                                {t('loggedInMessage', {name: userBox.first_name})}
                            </LoggedInUser>
                            <div onClick={() => goToLink('profile/bookings')}>{t('my-bookings')}</div>
                            <div onClick={() => goToLink('profile/details')}>{t('personal-details')}</div>
                            {hasInvoicesPage && <div onClick={() => goToLink('profile/invoices')}>{t('my-invoices')}</div>}
                            <div onClick={logoutUser}>{t('logout')}</div>
                        </FlexColumnSection>
                    }
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                    {!loggedIn &&
                        <>
                            <FlexBtn onClick={openLogin}>{t('login')}</FlexBtn>
                        </>
                    }
                    <SpaceBetweenRow>
                        <span style={{fontWeight: 500}}>{t('select-language')}</span>
                        <FlexRowSection gap={'10px'} flex={'initial'}>
                            <LangOption selected={language?.code === 'en'} onClick={() => onChangeLang('en', dispatch)}>EN</LangOption>
                            <SeparatorVerticalDiv />
                            <LangOption selected={language?.code === 'he'} onClick={() => onChangeLang('he', dispatch)}>עב</LangOption>
                        </FlexRowSection>
                    </SpaceBetweenRow>
                </div>
            </div>
        </Drawer>
    );
};

export default MobileMenu;

const FlexBtn = styled(Btn)`
    width: 100%
`;

const LangOption = styled(ClickableDiv)`
    height: 20px;
    text-decoration: ${({selected}) => selected ? 'underline' : 'none'};
`;

const SpaceBetweenRow = styled(FlexRowSection)`
    justify-content: space-between;
    padding: 16px 0 8px;
`;

const LoggedInUser = styled(FlexRowSection)`
    font-weight: bold;
`;


